<template>
  <el-container>
    <el-main style="background-image: url(/loginimg/bg_caiw.jpg);">
      <table style="width:1000px;height:100%;margin:auto">
        <tbody>
        <tr>
          <td style="width: 345px;">
            <img class="img_wanzhuan" :src="loginimg">
          </td>
          <td>
            <img class="img_phone" src="/app/img/sellapp.png" style="width: 120px; z-index:99999;right:15px;bottom:70px;position: absolute;">
          </td>
          <td style="width: 380px;">
            <el-form :model="form" label-position="left" label-width="0px" class="loginarea" :rules="rules"
                     style="background-image: url(/static/img/login/textbg.png);"
                     ref="form1">
              <h3 class="logintitle" style="margin-bottom: 30px">
                <el-tabs style="float:left;width:220px">
                  <el-tab-pane label="快速注册"></el-tab-pane>
                </el-tabs>
              </h3>
              <el-form-item prop="LoginName">
                <el-input prefix-icon="el-icon-mobile-phone" type="text" v-model="form.LoginName"
                          auto-complete="off"
                          placeholder="请输入手机号"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focususername }"
                          v-on:blur="focususername=false"></el-input>
              </el-form-item>
              <el-form-item prop="smsiden">
                <el-input prefix-icon="el-icon-edit-outline" v-model="form.smsiden"
                          auto-complete="off"
                          placeholder="请输入验证码"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focussmsiden }"
                          v-on:blur="focussmsiden=false" style="width: 184px"></el-input>
                <el-button type="primary" round @click="getCode" :disabled="!canpost" style="width: 118px">{{countName}}</el-button>
              </el-form-item>
              <el-form-item style="width:100%;">
                <el-button type="primary" style="width:80%;" @click.native.prevent="login"
                           :disabled="hasSubmit">登录
                </el-button>
              </el-form-item>
            </el-form>
            <TenantList ref="TenantList" :datalist="tenantlist" @selectTenant="selectTenant"></TenantList>
            <RegisterPW ref="RegisterPW" @AfterRegister="AfterRegister"></RegisterPW>
            <RegisterPre ref="RegisterPre" @AfterRegister="AfterRegister"></RegisterPre>
          </td>
        </tr>
        </tbody>
      </table>
    </el-main>
    <el-footer>Copyright © {{yearflag}} <a href="https://beian.miit.gov.cn/" target="_blank">{{ICP}}</a></el-footer>
  </el-container>
</template>
<script>
  import TenantList from './TenantList'
  import RegisterPW from './RegisterPW'
  import RegisterPre from './RegisterPre'
  import {login, setTenant, getTenantSet,sendVerificationCode} from '../../api/login'

  export default {
    name: "login",
    data() {
      return {
        loginparam: [],
        activeName: 'first',
        hasSubmit: false,
        formLabelWidth: '120px',
        tenantlist: [],
        countName: '获取验证码',
        count: 60,
        timer: null,
        canpost: true,
        applist: [],//应用集合
        loginimg: '',
        beforelogintenantid: '',
        yearflag:2021,
        ICP:'',
        form: {
          LoginName: '',//18951936622
          PassWord: '',//88888
          smsiden: '',
        },
        checked: true,
        rules: {
          LoginName: [
            {required: true, message: '请输入手机号', trigger: 'change'},
          ],
          PassWord: [
            {required: true, message: '请输入密码', trigger: 'change'},
          ],
          smsiden: [
            {required: true, message: '请输入验证码', trigger: 'change'},
          ]
        },
        focususername: false,
        focuspassword: false,
        focussmsiden: false,
        machinecode: '',//机器码
      }
    },
    methods: {
      login() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            if (this.hasSubmit)
              return;
            this.hasSubmit = true;

            //调用登录接口
            login({
              loginName: this.form.LoginName,
              password: '',
              smsiden:  this.form.smsiden ,
              LoginFrom: "member",
              tenantid:'1036ed24-71f5-4049-abe8-650410eda145',
            }).then(response => {
              setTimeout(() => {
                this.hasSubmit = false;
              }, 2000);
              if (response.data.code == 0||(response.data.code == 1 && response.data.handletype == 'register')) {//全局登录成功

                localStorage.setItem("hpapi_token", response.data.token);

                var tokenInfo = response.data.obj;

                tokenInfo.attviewpath = this.loginparam.attviewpath
                localStorage.setItem("hpapi_tokenModel", JSON.stringify(tokenInfo));
                if (response.data.handletype == 'register') {//跳转到注册流程
                  this.$refs.RegisterPre.show(this.form.LoginName);
                  return;
                }


                if (tokenInfo.tenantDO.length == 1) {
                  var tenantDo = tokenInfo.tenantDO[0];
                  this.selectTenant(tenantDo);
                } else {//存在多个
                  this.tenantlist = tokenInfo.tenantDO;
                  this.$refs.TenantList.dialogFormVisible = true;
                }
              } else {
                //登录失败
                if (response.data.handletype) {
                  if (response.data.handletype == 'setpw') {//首次登录，请设置密码！
                    this.$refs.RegisterPW.show('首次登录，请设置密码！', this.form.LoginName, this.form.smsiden);
                  }
                }
                else {
                  this.focususername = true;
                  this.$message.error({message: response.data.msg});
                }
              }
            }).catch((error) => {
              this.focususername = true;
              console.log(error)
            });

          } else {
            this.focususername = true;
            //this.$message.error('请核对手机号、密码是否正确!!')
            return false;
          }
        });
      },
      AfterRegister(mobile, pw) {
        if (mobile && pw) {
          this.form.LoginName = mobile;
          this.form.PassWord = pw;
        }
        this.hasSubmit = false;
        this.login();
      },
      getCode() {
        if (this.form.LoginName == '')
          return;
        const TIME_COUNT = 60;
        if (!this.timer) {
          var self = this;
          self.count = TIME_COUNT;
          if (self.canpost) {
            sendVerificationCode({type: 'login', mobile: this.form.LoginName}).then(response => {
              this.$message({
                message: '验证码发送成功！',
                type: 'success'
              })
            });
          }
          self.canpost = false;
          self.timer = setInterval(() => {
            if (self.count > 0 && self.count <= TIME_COUNT) {
              self.count--;
              self.countName = '' + self.count + 's';
            } else {
              self.canpost = true;
              self.countName = '获取验证码';
              clearInterval(self.timer);
              self.timer = null;
            }
          }, 1000)
        }
      },
      selectTenant(row) {
        if (window.location.host.indexOf('localhost') > -1) {//本地调试用
          row.appurl = 'http://' + window.location.host + '/#/index'
          row.apiurl = ''
        }
        setTenant({
          appguid: row.appguid,
          tenantID: row.unitguid,
          machinecode: this.machinecode,//机器码
          rs: 1,
          uguid: row.uguid,
          apiurl: row.apiurl,
          isAppChanged: true,
        }).then(responseUser => {
          if (responseUser.data.code == 0) {
            localStorage.setItem("hpapi_userInfoModel", JSON.stringify(responseUser.data.obj));
            document.title = responseUser.data.obj.tenantname;// + "【" + row.appname + "】";
            localStorage.setItem("tenantid", row.unitguid);

            //跳转到指定路由
            var RoutePath = '';
            let tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
            var tenantModel = tokenModel.tenantDO;
            // for (var i = 0; i < tenantModel.length; i++) {
            //   if (tenantModel[i].unitguid == responseUser.data.obj.tenantid && tenantModel[i].uguid == responseUser.data.obj.uguid)
            //     RoutePath = tenantModel[i].mainurl;
            // }

            var hrefroute = '';
            if (RoutePath && RoutePath != '') {
              hrefroute = RoutePath;// this.$route.params.redirect
            } else {
              localStorage.setItem("appguid", row.appguid);
              hrefroute = row.appurl + "?appguid=" + row.appguid
                + "&token=" + localStorage.getItem("hpapi_token");
            }
            if (row.ifusemember == -1) {//跳转到初始化页面
              localStorage.setItem("hrefroute", hrefroute);
              this.$router.push("/Register");
            } else {
              window.location.href = hrefroute;
            }

          } else {//获取错误
            this.focususername = true;
            this.$message({
              message: responseUser.data.msg,
              type: 'error',
              duration: 15000,
            });
          }
        });
      },
      cancel() {
        localStorage.removeItem("hpapi_token");
        localStorage.removeItem("hpapi_tokenModel");
        localStorage.removeItem("hpapi_userInfoModel");
      }
    },
    mounted() {
      var host = window.location.host;
      getTenantSet({"website": host}).then(reponse => {
        this.loginparam = reponse.data;
        this.loginimg = reponse.data.apiset.loginimg;
        document.title = reponse.data.tenantname;
        this.beforelogintenantid = reponse.data.tenantid;
      });
      this.yearflag = new Date().getFullYear();
      if (host.indexOf("eyes.wang") > -1) {
        this.ICP = "苏ICP备19004653号-1";
      } else {
        this.ICP = " 苏ICP备16001801号-1";//zyanjing.com
      }
    },
    components: {
      TenantList,
      RegisterPW,
      RegisterPre
    }
  }
</script>

<style scoped>

  .el-main {
    padding: 0px;
    width: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    height: 100%;
    line-height: 100%;
    position: fixed;
    text-align: center;
  }

  .el-input {
    width: 80%;
    font-size: 16px;
    color: #333333;
  }

  .el-form-item__error {
    padding-left: 40px !important;
  }

  .loginarea {
    width: 380px;
    height: 380px;
    background-position: center center;
    background-repeat: no-repeat;
    margin-top: 15px;
  }

  .logintitle {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    padding-left: 20px;
    font-weight: bold;
    color: #333;
    letter-spacing: 5px;
    text-align: left;
  }

  .BottomFont {
    color: #409EFF;
    float: right;
    padding-right: 60px;
    font-size: 14px;
    cursor: pointer;
  }

  .el-footer {
    padding: 0px;
    background-color: #ffffff;
    height: 60px;
    font-size: 14px;
    color: #4f616e;
    text-align: center;
    line-height: 60px;
    position: fixed;
    bottom: 0px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/login/loginMen.vue